// extracted by mini-css-extract-plugin
export default {"container":"info-block_container__n2lAh","toggle":"info-block_toggle__ka8Ph"};